import { Collection as BackboneCollection } from 'backbone'
import { Defaults } from 'es-decorators'
import { Model } from './model'

/**
 * Базовая коллекция
 */
@Defaults({
  model: Model,
})
export class Collection extends BackboneCollection {
  /**
   * @inheritDoc
   */
  url () {
    let fragment = '/'
    if (this.expand) {
      fragment += '?' + this.expand
    }
    if (this.requestParameters) {
      fragment += (this.expand ? '&' : '?') + this.requestParameters
    }
    return this.urlRoot + fragment
  }
  /**
   * @inheritDoc
   */
  parse (response) {
    return response.items
  }
  /**
   * @inheritDoc
   */
  initialize (models, options) {
    this.beforeRun(models, options)
    this.run(models, options)
    this.afterRun(models, options)
    this.fetchCounter = 0
  }
  /**
   * @inheritDoc
   */
  fetch () {
    this.fetchCounter++
    return BackboneCollection.prototype.fetch.apply(this, arguments)
  }
  /**
   * Запускается во время инициализации, перед run
   * @param {Array} [models]
   * @param {Object} [options]
   */
  beforeRun (models, options) {}
  /**
   * Запускается во время инициализации
   * @param {Array} [models]
   * @param {Object} [options]
   */
  run (models, options) {}
  /**
   * Запускается во время инициализации, после run
   * @param {Array} [models]
   * @param {Object} [options]
   */
  afterRun (models, options) {}
}
